module.exports = __webpack_public_path__ + "img/Patricia Feldt.4324d450.jpg";